/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

const Layout = ({ children }) => {
  return (
    <>
      <div
        style={{ backgroundColor: "black", color: "white", padding: "0.5rem 1rem" }}
      >
        <a href={"/fes"} style={{ color: "white" }}>
          {" "}
          [お知らせ] Internal Meeting Festival を開催します。{" "}
        </a>
      </div>
      <main>{children}</main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
